class CertificateInfoHelper {
  getFopEdrpouFromCertInfo(certInfo: any): string {
    return certInfo ? certInfo.subjEDRPOUCode || certInfo.subjDRFOCode || '' : '';
  }
  getFopOrgNameFromCertInfo(certInfo: any): string {
    return certInfo ? certInfo.subjOrg || certInfo.subjCN || '' : '';
  }
}

export const certificateInfoHelper = new CertificateInfoHelper();
